import { HookOutOfContextError } from "@jugl-web/utils";
import { useContext } from "react";
import { ActiveTimeTrackingContext } from "./ActiveTimeTrackingContext";

export const useActiveTimeTrackingContext = () => {
  const context = useContext(ActiveTimeTrackingContext);

  if (!context) {
    throw new HookOutOfContextError(
      "useActiveTimeTrackingContext",
      "ActiveTimeTrackingContext"
    );
  }

  return context;
};
